module.exports = __webpack_public_path__ + "img/competitor-analysis-banner.218a2b48.png";